import React from 'react';

function Logo({ height = 80, variant = 'dark', className = '' }) {
  const textColor = variant === 'dark' ? '#0a2540' : 'white';
  const subtitleColor = variant === 'dark' ? '#D4AF37' : '#D4AF37';
  
  return (
    <svg 
      width={height * 3.5} 
      height={height} 
      viewBox="0 0 400 150" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Nube */}
      <path 
        d="M140 45C140 35 148 27 158 27C161 20 168 15 177 15C187 15 196 21 199 30C208 30 215 37 215 46C215 55 208 62 199 62H150C145 62 140 58 140 53V45Z" 
        stroke="#D4AF37" 
        strokeWidth="4" 
        fill="none"
      />
      
      {/* Línea vertical central */}
      <line 
        x1="177" 
        y1="62" 
        x2="177" 
        y2="78" 
        stroke="#D4AF37" 
        strokeWidth="4"
      />
      
      {/* Conexiones horizontales */}
      <line 
        x1="130" 
        y1="95" 
        x2="224" 
        y2="95" 
        stroke="#D4AF37" 
        strokeWidth="4"
      />
      
      {/* Líneas verticales a círculos */}
      <line x1="140" y1="78" x2="140" y2="95" stroke="#D4AF37" strokeWidth="4"/>
      <line x1="160" y1="78" x2="160" y2="95" stroke="#D4AF37" strokeWidth="4"/>
      <line x1="194" y1="78" x2="194" y2="95" stroke="#D4AF37" strokeWidth="4"/>
      <line x1="214" y1="78" x2="214" y2="95" stroke="#D4AF37" strokeWidth="4"/>
      
      {/* Círculos en los extremos */}
      <circle cx="125" cy="102" r="6" stroke="#D4AF37" strokeWidth="4" fill="none"/>
      <circle cx="140" cy="108" r="6" stroke="#D4AF37" strokeWidth="4" fill="none"/>
      <circle cx="160" cy="108" r="6" stroke="#D4AF37" strokeWidth="4" fill="none"/>
      <circle cx="194" cy="108" r="6" stroke="#D4AF37" strokeWidth="4" fill="none"/>
      <circle cx="214" cy="108" r="6" stroke="#D4AF37" strokeWidth="4" fill="none"/>
      <circle cx="229" cy="102" r="6" stroke="#D4AF37" strokeWidth="4" fill="none"/>
      
      {/* Texto KREANDO */}
      <text 
        x="50%" 
        y="135" 
        textAnchor="middle" 
        fill={textColor} 
        fontSize="32" 
        fontWeight="800"
        fontFamily="Arial, sans-serif"
        letterSpacing="2"
      >
        KREANDO
      </text>
      
      {/* Texto SOFTWARE */}
      <text 
        x="50%" 
        y="148" 
        textAnchor="middle" 
        fill={subtitleColor} 
        fontSize="16" 
        fontWeight="600"
        fontFamily="Arial, sans-serif"
        letterSpacing="4"
      >
        SOFTWARE
      </text>
    </svg>
  );
}

export default Logo;
